export default __webpack_public_path__ + "static/media/trash-red.1e3f926e.svg";